import { isBefore, isToday, isValid, parse } from 'date-fns';

export const tryParseDate = (input: string): Date => {
	const regex = /(?<day>[0-9]{2})\.?(?<month>[0-9]{2})\.?(?<year>[0-9]{2,4})?/;

	const parseString = regex.exec(input);

	const date = parseString?.groups['day'],
		month = parseString?.groups['month'],
		year = parseString?.groups['year'];

	let newDate: Date = null;

	if (date && month) {
		if (!year) {
			newDate = parse(`${date}.${month}`, 'dd.MM', new Date());
		} else if (year.length === 2) {
			newDate = parse(`${date}.${month}.${year}`, 'dd.MM.yy', new Date());
		} else if (year.length === 4) {
			newDate = parse(`${date}.${month}.${year}`, 'dd.MM.yyyy', new Date());
		}
	}

	if (isValid(newDate) && (isBefore(new Date(), newDate) || isToday(newDate))) {
		return newDate;
	}

	return null;
};
